<template>
  <v-app>
    <v-main class="page-background">

      <!-- =====================================================
           HERO
           ===================================================== -->
      <section class="hero-section">

        <!-- HERO-BILD -->
        <img
          :src="Gebauedebg"
          alt="Professionelle Gebäudereinigung"
          class="hero-image"
        />

        <!-- HERO-INHALT -->
        <div class="hero-content">

          <v-container class="hero-container">

            <div class="hero-copy">

              

              <h1 class="hero-title">
                Gebäudereinigung
              </h1>

              <div class="green-line"></div>

              <div class="hero-text">

                <p>
                  In der Gebäudereinigung wird viel geleistet.
                </p>

                <p>
                  Oft im Hintergrund, oft unter Zeitdruck
                  und meist dann, wenn andere schon gegangen sind.
                </p>

                <p>
                  Vieles läuft routiniert.
                  Und trotzdem stellt sich immer wieder die Frage,
                  ob das, was gemacht wird, auch wirklich richtig gemacht wird.
                </p>

              </div>

            </div>

          </v-container>

        </div>

      </section>


      <!-- =====================================================
           INFO-BEREICH
           ===================================================== -->
      <section class="info-section">

        <v-container class="info-container">

          <v-card
            class="info-card"
            elevation="0"
          >

            <!-- ICON -->
            <div class="info-icon-wrapper">

              <v-icon
                icon="mdi-broom"
                class="info-icon"
                size="64"
              />

            </div>


            <!-- TEXT -->
            <div class="info-content">

              <h2>
                Genau hier setzen wir an.
              </h2>

              <p>
                Wir unterstützen Reinigungsteams und Verantwortliche dabei,
                Hygiene zu verstehen und sicher umzusetzen.
              </p>

              <p>
                Nicht über Vorschriften,
                sondern über Klarheit im Tun.
              </p>

            </div>

          </v-card>

        </v-container>

      </section>

    </v-main>
  </v-app>
</template>


<script setup>

/* =========================================================
   HINTERGRUNDBILD
   ========================================================= */

/*
 * Datei:
 * GebaudeBg.png
 *
 * Importname:
 * Gebauedebg
 */

import Gebauedebg from '../assets/GebaudeBg.png'

</script>


<style scoped>

/* =========================================================
   GRUNDLAYOUT
   ========================================================= */

.page-background {
  background: #ffffff;

  color: #171b22;

  min-height: 100vh;

  overflow-x: hidden;
}


/* =========================================================
   HERO
   ========================================================= */

.hero-section {
  position: relative;

  width: 100%;

  min-height: 650px;

  overflow: hidden;

  background: #ffffff;
}


/* =========================================================
   HERO BILD
   ========================================================= */

.hero-image {
  position: absolute;

  inset: 0;

  z-index: 0;

  width: 100%;
  height: 100%;

  display: block;

  object-fit: cover;

  object-position: center center;
}


/* =========================================================
   HERO CONTENT
   ========================================================= */

.hero-content {
  position: relative;

  z-index: 2;

  min-height: 650px;
}


/* =========================================================
   HERO CONTAINER
   ========================================================= */

.hero-container {
  max-width: 1280px !important;

  min-height: 650px;

  display: flex;

  align-items: center;

  padding-top: 70px;

  padding-bottom: 70px;
}


/* =========================================================
   HERO COPY
   ========================================================= */

.hero-copy {
  width: min(720px, 100%);

  margin-left: 0;
}


/* =========================================================
   EYEBROW
   ========================================================= */

.eyebrow {
  margin-bottom: 18px;

  font-size: 16px;

  line-height: 1.2;

  font-weight: 500;

  letter-spacing: 0.28em;

  color: #151a22;
}


/* =========================================================
   HERO TITLE
   ========================================================= */

.hero-title {
  margin: 0;

  font-size: clamp(52px, 5.5vw, 86px);

  line-height: 0.98;

  font-weight: 800;

  letter-spacing: -0.045em;

  color: #171b22;
}


/* =========================================================
   GRÜNE LINIE
   ========================================================= */

.green-line {
  width: 125px;

  height: 6px;

  margin-top: 28px;

  margin-bottom: 28px;

  border-radius: 999px;

  background: #65b51b;
}


/* =========================================================
   HERO TEXT
   ========================================================= */

.hero-text {
  max-width: 690px;

  font-size: 22px;

  line-height: 1.55;

  font-weight: 400;

  color: #20242b;
}


.hero-text p {
  margin: 0 0 18px;
}


.hero-text p:last-child {
  margin-bottom: 0;
}


/* =========================================================
   INFO-BEREICH
   ========================================================= */

.info-section {
  position: relative;

  z-index: 5;

  margin-top: 0;

  padding: 30px 0 80px;

  background: #ffffff;
}


.info-container {
  max-width: 1380px !important;
}


/* =========================================================
   INFO CARD
   ========================================================= */

.info-card {
  min-height: 250px;

  display: flex;

  align-items: center;

  gap: 55px;

  padding: 42px 70px;

  border-radius: 16px !important;

  border-left: 8px solid #65b51b;

  background: rgba(248, 248, 247, 0.97) !important;

  box-shadow:
    0 12px 35px rgba(0, 0, 0, 0.06) !important;
}


/* =========================================================
   INFO ICON
   ========================================================= */

.info-icon-wrapper {
  flex: 0 0 145px;

  width: 145px;

  height: 145px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 50%;

  background: #ffffff;

  box-shadow:
    0 8px 25px rgba(101, 181, 27, 0.12);
}


.info-icon {
  color: #65b51b !important;
}


/* =========================================================
   INFO CONTENT
   ========================================================= */

.info-content {
  flex: 1;
}


.info-content h2 {
  margin: 0 0 10px;

  font-size: 34px;

  line-height: 1.2;

  font-weight: 800;

  letter-spacing: -0.025em;

  color: #171b22;
}


.info-content p {
  max-width: 900px;

  margin: 0 0 12px;

  font-size: 21px;

  line-height: 1.45;

  color: #24282f;
}


.info-content p:last-child {
  margin-bottom: 0;
}


/* =========================================================
   TABLET
   ========================================================= */

@media (max-width: 1100px) {

  .hero-section,
  .hero-content,
  .hero-container {
    min-height: 610px;
  }


  .hero-container {
    padding-left: 42px;

    padding-right: 42px;
  }


  .hero-copy {
    width: min(650px, 100%);
  }


  .hero-title {
    font-size: clamp(48px, 6vw, 72px);
  }


  .hero-text {
    font-size: 20px;
  }


  .info-card {
    padding: 36px 45px;

    gap: 40px;
  }

}


/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 767px) {

  /* -------------------------------------------------------
     HERO
     ------------------------------------------------------- */

  .hero-section {
    min-height: auto;

    overflow: visible;

    background: #ffffff;
  }


  /*
   * Das Bild befindet sich auf Mobile in einem eigenen
   * Bereich oberhalb des Textes.
   */

  .hero-image {
    position: relative;

    inset: auto;

    width: 100%;

    height: 300px;

    display: block;

    object-fit: cover;

    object-position: 68% center;
  }


  /* -------------------------------------------------------
     HERO CONTENT
     ------------------------------------------------------- */

  .hero-content {
    min-height: auto;

    background: #ffffff;
  }


  .hero-container {
    min-height: auto;

    display: block;

    padding: 0 !important;
  }


  .hero-copy {
    width: 100%;

    padding: 28px 20px 34px;

    background: #ffffff;
  }


  /* -------------------------------------------------------
     EYEBROW
     ------------------------------------------------------- */

  .eyebrow {
    margin-bottom: 14px;

    font-size: 12px;

    line-height: 1.2;

    letter-spacing: 0.22em;
  }


  /* -------------------------------------------------------
     HERO TITLE
     ------------------------------------------------------- */

  .hero-title {
    font-size: clamp(42px, 12vw, 58px);

    line-height: 1;

    letter-spacing: -0.045em;

    overflow-wrap: anywhere;

    word-break: normal;
  }


  /* -------------------------------------------------------
     GRÜNE LINIE
     ------------------------------------------------------- */

  .green-line {
    width: 95px;

    height: 5px;

    margin-top: 22px;

    margin-bottom: 24px;
  }


  /* -------------------------------------------------------
     HERO TEXT
     ------------------------------------------------------- */

  .hero-text {
    max-width: none;

    font-size: 18px;

    line-height: 1.5;
  }


  .hero-text p {
    margin-bottom: 17px;
  }


  /* =======================================================
     INFO-BEREICH
     ======================================================= */

  .info-section {
    padding: 0 0 45px;
  }


  .info-container {
    padding: 0 14px !important;
  }


  .info-card {
    min-height: auto;

    display: flex;

    flex-direction: column;

    align-items: center;

    gap: 22px;

    padding: 30px 22px 32px;

    border-left: 5px solid #65b51b;

    border-radius: 14px !important;

    text-align: center;
  }


  /* -------------------------------------------------------
     INFO ICON
     ------------------------------------------------------- */

  .info-icon-wrapper {
    flex: 0 0 auto;

    width: 105px;

    height: 105px;
  }


  .info-icon {
    font-size: 48px !important;
  }


  /* -------------------------------------------------------
     INFO CONTENT
     ------------------------------------------------------- */

  .info-content {
    width: 100%;
  }


  .info-content h2 {
    font-size: 27px;

    line-height: 1.2;

    margin-bottom: 12px;
  }


  .info-content p {
    font-size: 18px;

    line-height: 1.5;
  }

}


/* =========================================================
   SEHR KLEINE SMARTPHONES
   ========================================================= */

@media (max-width: 420px) {

  .hero-image {
    height: 250px;

    object-position: 70% center;
  }


  .hero-copy {
    padding: 24px 14px 30px;
  }


  .hero-title {
    font-size: 40px;

    line-height: 1;

    letter-spacing: -0.045em;
  }


  .hero-text {
    font-size: 17px;
  }


  .info-card {
    padding: 26px 18px 28px;
  }


  .info-content h2 {
    font-size: 24px;
  }


  .info-content p {
    font-size: 17px;
  }

}

</style>